/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceCatalogueDto
 */
export interface DeviceCatalogueDto {
    /**
     *
     * @type {number}
     * @memberof DeviceCatalogueDto
     */
    deviceCatalogueId?: number;
    /**
     * Unique id, required. Used in NetSuite, online store, partner store, etc.
     * @type {string}
     * @memberof DeviceCatalogueDto
     */
    jetChargeSku?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceCatalogueDto
     */
    deviceType?: DeviceCatalogueDtoDeviceTypeEnum;
    /**
     * AC or DC charger. Defined by the hardware capability of the device/SKU, not by the actual installation wiring (it is common for an SKU that supports 3-phase AC to be installed in a single-phase configuration).
     * @type {string}
     * @memberof DeviceCatalogueDto
     */
    powerType?: DeviceCatalogueDtoPowerTypeEnum;
    /**
     * Simplified vendor name.
     * @type {string}
     * @memberof DeviceCatalogueDto
     */
    simpleVendor?: string;
    /**
     * Simplified model name, to be displayed in place of Device.Model. Usually begins with the vendor name.
     * @type {string}
     * @memberof DeviceCatalogueDto
     */
    simpleModel?: string;
    /**
     * Full product name
     * @type {string}
     * @memberof DeviceCatalogueDto
     */
    productName?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceCatalogueDto
     */
    description?: string;
    /**
     * Vendor SKU. It may be possible to have unrelated vendors using the same SKU, so this is not guaranteed to be unique.
     * @type {string}
     * @memberof DeviceCatalogueDto
     */
    vendorSku?: string;
    /**
     * Device reported Vendor
     * @type {string}
     * @memberof DeviceCatalogueDto
     */
    reportedVendor?: string;
    /**
     * Device reported Model, used for Model drop-down during provisioning to match DeviceConfigurationSchemas.
     * @type {Array<string>}
     * @memberof DeviceCatalogueDto
     */
    reportedModels?: Array<string>;
    /**
     *
     * @type {Date}
     * @memberof DeviceCatalogueDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof DeviceCatalogueDto
     */
    updatedAt?: Date;
}

/**
 * @export
 */
export const DeviceCatalogueDtoDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type DeviceCatalogueDtoDeviceTypeEnum =
    (typeof DeviceCatalogueDtoDeviceTypeEnum)[keyof typeof DeviceCatalogueDtoDeviceTypeEnum];

/**
 * @export
 */
export const DeviceCatalogueDtoPowerTypeEnum = {
    Unknown: "Unknown",
    Ac1Phase: "AC1Phase",
    AcSplitPhase: "ACSplitPhase",
    Ac3Phase: "AC3Phase",
    Acdc: "ACDC",
    Dc: "DC",
} as const;
export type DeviceCatalogueDtoPowerTypeEnum =
    (typeof DeviceCatalogueDtoPowerTypeEnum)[keyof typeof DeviceCatalogueDtoPowerTypeEnum];

/**
 * Check if a given object implements the DeviceCatalogueDto interface.
 */
export function instanceOfDeviceCatalogueDto(
    value: object,
): value is DeviceCatalogueDto {
    return true;
}

export function DeviceCatalogueDtoFromJSON(json: any): DeviceCatalogueDto {
    return DeviceCatalogueDtoFromJSONTyped(json, false);
}

export function DeviceCatalogueDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceCatalogueDto {
    if (json == null) {
        return json;
    }
    return {
        deviceCatalogueId:
            json["deviceCatalogueId"] == null
                ? undefined
                : json["deviceCatalogueId"],
        jetChargeSku:
            json["jetChargeSku"] == null ? undefined : json["jetChargeSku"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        powerType: json["powerType"] == null ? undefined : json["powerType"],
        simpleVendor:
            json["simpleVendor"] == null ? undefined : json["simpleVendor"],
        simpleModel:
            json["simpleModel"] == null ? undefined : json["simpleModel"],
        productName:
            json["productName"] == null ? undefined : json["productName"],
        description:
            json["description"] == null ? undefined : json["description"],
        vendorSku: json["vendorSku"] == null ? undefined : json["vendorSku"],
        reportedVendor:
            json["reportedVendor"] == null ? undefined : json["reportedVendor"],
        reportedModels:
            json["reportedModels"] == null ? undefined : json["reportedModels"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
    };
}

export function DeviceCatalogueDtoToJSON(
    value?: DeviceCatalogueDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceCatalogueId: value["deviceCatalogueId"],
        jetChargeSku: value["jetChargeSku"],
        deviceType: value["deviceType"],
        powerType: value["powerType"],
        simpleVendor: value["simpleVendor"],
        simpleModel: value["simpleModel"],
        productName: value["productName"],
        description: value["description"],
        vendorSku: value["vendorSku"],
        reportedVendor: value["reportedVendor"],
        reportedModels: value["reportedModels"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
    };
}
